import { generatePath } from 'react-router-dom';
import { RESULTS_URL_FRAGMENT } from '../../constants/Navigation';
import { FILTER_CONSTS, FILTER_TYPES } from '../../constants/TopFilterConstants';
export const getSearchUrl = ({
  language,
  showOnlyCerts,
  tool,
  category,
  contentType
}) => {
  const urlParams = new URLSearchParams();
  if (contentType) urlParams.set(FILTER_TYPES.CONTENT_TYPE, contentType);
  if (language) {
    if (Array.isArray(language)) {
      language.forEach(lang => urlParams.append(FILTER_TYPES.LANGUAGE, lang.toUpperCase()));
    } else {
      urlParams.set(FILTER_TYPES.LANGUAGE, language.toUpperCase());
    }
  }
  if (showOnlyCerts) urlParams.set(FILTER_TYPES.AWARD_TYPE, FILTER_CONSTS.AWARD_TYPES.ONLY_SHOW_CERTIFICATE_COURSES);
  if (tool) {
    if (Array.isArray(tool)) {
      tool.forEach(t => urlParams.append(FILTER_TYPES.TOOLS, t));
    } else {
      urlParams.set(FILTER_TYPES.TOOLS, tool);
    }
  }
  if (category) urlParams.set(FILTER_TYPES.CATEGORY, category);
  const pathname = generatePath(RESULTS_URL_FRAGMENT);
  const search = urlParams.toString();
  return {
    search,
    pathname,
    hash: '',
    state: undefined,
    fullUrl: `${pathname}${search ? `?${search}` : ''}`
  };
};